import GradeTable from "./GradeTable";

export default GradeTable;